import React, {useEffect, useMemo} from 'react';
import {useSearchParams} from "react-router-dom";
import BackendForm from "../components/forms/BackendForm";
import Pages from "../components/layout/Pages";
import {routes} from "../utils";
import useAuth from "../components/hooks/useAuth";
import {useNavigate} from "react-router";
import {At, Lock} from "react-bootstrap-icons";
import {backendEndpoints} from "../libs/backendEndpoints";
import useTitle from "../components/hooks/useTitle";
import FormFiller from "../components/forms/FormFiller";
import {User as BackendUser} from "fearless-common/src/backendModels";
import {Alert, Button} from 'fearless-common-ui';
import {FloatingLabelField} from "../components/forms";

const formId = 'login-form';

const answerSets = [
  {
    title: 'A. Williams',
    answers: [{name: 'email_or_username', value: 'alex.williams@divvly.com'}, {name: 'password', value: 'password'}]
  },
  {
    title: 'S. Hariri',
    answers: [{name: 'email_or_username', value: 'sam.hariri@divvly.com'}, {name: 'password', value: 'password'}]
  },
];

export default function Login() {
  useTitle('Log in');


  return (
    <Pages.Centred width="xs">
      <h1 className="text-center mb-5">Log in</h1>
      <Login.Form/>
      <div className="bg-dark-transparent py-5 px-5 text-center mt-5 rounded-bottom-lg">
        <strong className="text-lg d-block mb-3 text-white">Don't have an account yet?</strong>
        <a href={routes.signUp}>
          <Button size="lg">Create an account</Button>
        </a>
      </div>
    </Pages.Centred>
  );
}

/**
 * Reusable login form which can be used in many places on the website for quicker login.
 * @constructor
 */
function LoginForm({redirectUrl = ''}: { redirectUrl?: string }) {
  const {saveToken, user, isLoading} = useAuth();
  const navigate = useNavigate();
  const [sp] = useSearchParams();

  const message = sp.get('message');
  const email = sp.get('email');

  useEffect(() => {
    if (!isLoading && user && !message) {
      navigate(routes.dashboard);
    }
  }, [user, isLoading]);

  const initialObject = useMemo(() => ({
    email_or_username: email || '',
    password: '',
  }), [message, email]);

  return (
    <>
      {message && (
        <Alert variant="info">{message}</Alert>
      )}
      <BackendForm<typeof initialObject, { token: string; user: BackendUser; two_factor: false }>
        initialValues={initialObject}
        targetEndpoint={backendEndpoints.login}
        targetMethod="POST"
        onSuccess={({data}) => {
          saveToken(data.token);
          // Hard refresh, such that the login cookie read into the react state;
          if (data.two_factor) {
            window.location.href = routes.twoFactorChallenge;
          } else {
            window.location.href = redirectUrl || sp?.get('redirect') || routes.landing;
          }
        }}
        config={{
          withCredentials: true,
          withXSRFToken: true,
        }}
        footerContent={(
          <div className="py-2 d-inline-flex gap-3">
            <a href={routes.forgotPassword} className="btn-link fw-bold">Forgotten password?</a>
          </div>
        )}
        formId={formId}
      >
        <FloatingLabelField
          name="email_or_username"
          label="E-mail or username"
          icon={<At/>}
          disappearingLabel
          type="text"
        />
        <FloatingLabelField
          type="password"
          name="password"
          label="Password"
          icon={<Lock/>}
          disappearingLabel
        />
        <FormFiller formId={formId} answerSets={answerSets}/>
      </BackendForm>
    </>
  )
}

Login.Form = LoginForm
